'use client';

import Link from 'next/link';
import { getCurrentYear, PrivacyIcon } from '@libs/common-next';
import { dataLayerPush, layoutEvents } from '@libs/analytics';
import {
    ONETRUST_PRIVACY_OPTIONS_MODEL_CLASSNAME,
    PRIVACTY_OPTIONS_ICON_NAME,
} from '../../../constants';
import type { LegacyFooterSecondaryMenuProps } from './types';

const CURRENT_YEAR = getCurrentYear();

export function LegacyFooterSecondaryMenu({
    links,
    copyrightText,
}: LegacyFooterSecondaryMenuProps) {
    return (
        <div
            data-testid="legacy-footer-secondary-menu"
            className="legacy-footer__secondary-menu"
        >
            <div className="copyright-section">
                {`Copyright © ${CURRENT_YEAR} ${copyrightText ?? ''}`}
            </div>
            <div className="secondary-navigation">
                {links?.map(({ actionText, sysId, webUrl, iconName }) => {
                    // Cookie Privacy Options is a special link case
                    // It needs an icon, OneTrust integration and needs to avoid page reloads
                    const isPrivacyOptions =
                        iconName === PRIVACTY_OPTIONS_ICON_NAME;
                    return isPrivacyOptions ? (
                        <Link
                            className={`secondary-navigation__link ${ONETRUST_PRIVACY_OPTIONS_MODEL_CLASSNAME}`}
                            key={sysId}
                            href="javacript:void(0);"
                            prefetch={false} // https://petsmart.atlassian.net/browse/SB-325
                        >
                            {actionText}
                            <PrivacyIcon size={24} />
                        </Link>
                    ) : (
                        <Link
                            className="secondary-navigation__link"
                            key={sysId}
                            href={webUrl}
                            onClick={() =>
                                dataLayerPush({
                                    ...layoutEvents.footerClick,
                                    selection: actionText,
                                    link_url: webUrl,
                                })
                            }
                            prefetch={false} // https://petsmart.atlassian.net/browse/SB-325
                        >
                            {actionText}
                        </Link>
                    );
                })}
                <span className="secondary-navigation__link">FS</span>
            </div>
        </div>
    );
}
